import { Blobs } from './blob/Blobs';
import { BlobConfig } from './blob/BlobConfig';
import { getColorTheme } from './blob/blobUtils';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const BlobMessaging = ({
  blobKey,
  renderComponent,
  renderBleed,
  messageKey,
  colorThemeOption
}) => {
  const blobConfig = BlobConfig[blobKey];
  const {
    configColorThemeOption
  } = blobConfig;
  const colorTheme = colorThemeOption || configColorThemeOption;
  const theme = useTheme();
  const isTrellisThemeEnabled = isTrellisTheme(theme);
  return /*#__PURE__*/_jsx(Blobs, {
    colorTheme: getColorTheme(colorTheme, isTrellisThemeEnabled),
    messageKey: messageKey,
    renderBleed: renderBleed,
    children: renderComponent()
  });
};